<template>
  <router-view v-slot="{ Component }">
    <transition name="view" appear>
      <div class="browser">
        <component :is="Component" />
      </div>
    </transition>
  </router-view>
</template>
<script>
import { TEMPLATE_BROWSER } from '@/utils/constants';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'Browser',
  components: {},
  data: function () {
    return {};
  },
  computed: {
    // ...mapState('apmState/apmCommonState', ['currentService']),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'timezoneoffset',
    ]),
    ...mapGetters('browserState/browserCommonState', [
      'getCurrentBrowserService',
    ]),
  },
  methods: {
    ...mapMutations('globalState/app', ['toggleMenu', 'setTemplate']),
    ...mapActions('browserState/browserCommonState', ['selectBrowserService']),
    async removeQuery() {
      const currentRoute = this.$route;

      await this.$router.replace({
        path: currentRoute.path,
        query: null,
      });
    },
  },
  async mounted() {
    this.setTemplate(TEMPLATE_BROWSER);

    const { serviceId } = this.$route.query;

    if (serviceId) {
      const serviceInfo = parseServiceObjFromApplication({ key: serviceId });

      const params = {
        duration: this.getDurationTime,
        serviceId: {
          key: serviceId,
          label: serviceInfo.name,
        },
      };

      this.selectBrowserService(params);
      this.removeQuery();
    }
  },
  created() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.browser {
  width: 100%;
  height: 100%;
  //  margin-top: 1.1875em;
}
</style>
